import { render, staticRenderFns } from "./pogs-submissions__census.vue?vue&type=template&id=5c1c99d8&"
import script from "./pogs-submissions__census.vue?vue&type=script&lang=js&"
export * from "./pogs-submissions__census.vue?vue&type=script&lang=js&"
import style0 from "./pogs-submissions__census.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports